import React, { Fragment, useEffect, useState, useContext } from "react";
import { Link, withRouter } from "react-router-dom";
import styled, { css } from "styled-components";
import { Context } from "../context";
import { MenuMain } from "./MenuMain";
import { Playlist, PlaylistTop } from "./Playlist";
import { Player } from "./Player";

export function Projects({ videoId }) {
  const context = useContext(Context);
  return (
    <>
      <div className="b0">
        <MenuMain />

        <div className="c00">
          <div className="l_main0">
            <div className="l_main">
              {/* <DayFilters/> */}

              {/* <DayGrid/> */}

              {/* <LayoutSwitcher/> */}

              <div className="l_catalog">
                <div
                  className={`l_catalog_inner ${
                    videoId ? "l_catalog_inner--full" : ""
                  }`}
                >
                  <div className="l_catalog">
                    {context.data["projects"].map((one) => (
                      <div className="l_catalog_inner l_catalog_inner--sm">
                        <div
                          className="l_playlist l_playlist--sm"
                          // className="l_playlist"
                          key={`project_playlist_${one["id"]}`}
                        >
                          <PlaylistTop size="sm" {...one} />
                          <Playlist size={"sm"} {...one} />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {Boolean(videoId) && <Player />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
